module.exports = __webpack_public_path__ + "static/img/cabinet-manager.42bfa35.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cabinet-manager.png
// module id = etEC
// module chunks = 1